import type { User } from '@/types';
import type { UserValidationResult } from './types';

export function validateUserDeletion(user: User): UserValidationResult {
  // Check if user exists
  if (!user) {
    return { isValid: false, error: 'User not found' };
  }

  // Check if user is admin
  const isAdmin = user.roles?.some(r => r.role === 'admin' && r.isActive);
  if (isAdmin) {
    return { isValid: false, error: 'Cannot delete admin users' };
  }

  return { isValid: true };
}